import axios from "axios";

export const loadGlobalHeader = async () => {

    const baseUrl = process.env.REACT_APP_HEADER_URL;
    try {
        const res = await axios.get(baseUrl + 'asset-manifest.json');
        const files: string[] = res.data.entrypoints;
        files.forEach(f => {
            const url = baseUrl + f;
            if (f.endsWith('.js')) {
                importJsFile(url);
            } else if (f.endsWith('.css')) {
                importCssFile(url);
            }
        });
    } catch (error) {
        // header is unavailable, don't blow up the whole page.
    }

};

const importJsFile = (url: string) => {
    const scriptEl = document.createElement('script');
    scriptEl.src = url;
    scriptEl.type = 'text/javascript';

    const head = document.head;
    head.insertBefore(scriptEl, head.childNodes[0]);
};

const importCssFile = (url: string) => {
    const linkEl = document.createElement('link');
    linkEl.href = url;
    linkEl.rel = 'stylesheet';
    linkEl.type = 'text/css';

    const head = document.head;
    head.insertBefore(linkEl, head.childNodes[0]);
};
